import { Box, CircularProgress, Link, Typography } from "@mui/material";
import { GetCurrencyFixedToTwo } from "../../../utils/commonFunctions/GetCurrencyFixedToTwo";
import { useAppSelector } from "../../../app/hooks";
import {
  BrandNameUpdate,
  isLandingPage,
  isPromotionalLandingPage,
  renderTextStyles,
} from "../../../utils/commonFunctions";
import _ from "lodash";

type NLCardProps = {
  NLContent: any;
  plan: any;
  planPerLinesCost: any;
  minShipvalue: any;
  maxShipvalue: any;
  planCost: any;
};
const T2_NLCard = (props: NLCardProps) => {
  const { configKeys } = useAppSelector((state: any) => state?.activation);
  const { NLContent, planPerLinesCost, minShipvalue, maxShipvalue, planCost } =
    props;
  const { plan: p } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        display="flex"
        p={2}
        sx={{
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            color: "var(--title-color_1)",
          }}
        >
          <Typography
            sx={_.merge(renderTextStyles(1, "24px", "inherit", "36px"), {
              my: "5px",
            })}
          >
            {NLContent?.title}
          </Typography>
        </Box>
        <Box
          sx={{
            borderBottom: "6px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            color: "var(--title-color_1)",
          }}
        >
          <Typography
            sx={_.merge(renderTextStyles(1, "14px", "inherit", "21px"), {
              mt: "5px",
            })}
          >
            {BrandNameUpdate(NLContent?.brandname)}
          </Typography>
          <Typography
            sx={_.merge(renderTextStyles(1, "14px", "inherit", "21px"), {
              mt: "5px",
            })}
          >
            {p?.displayName}
          </Typography>

          <Typography
            sx={_.merge(renderTextStyles(4, "12px", "inherit", "18px"), {
              my: "5px",
            })}
            dangerouslySetInnerHTML={{ __html: NLContent.disclosure }}
          />
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid var(--title-color_1)",
            height: "max-content",
            color: "var(--title-color_1)",
            width: "100%",
            display: " flex",
            justifyContent: " space-between;",
            py: "5px",
          }}
        >
          <Typography sx={renderTextStyles(1, "14px", "inherit", "21px")}>
            {NLContent.mprice_heading}
          </Typography>
          <Typography sx={renderTextStyles(1, "14px", "inherit", "21px")}>
            {GetCurrencyFixedToTwo(planPerLinesCost)}
          </Typography>
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid var(--gains-boro)",
            color: "var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            justifyContent: " space-between;",
          }}
        >
          <Typography
            sx={_.merge(renderTextStyles(4, "10px", "inherit", "15px"), {
              my: "5px",
            })}
            dangerouslySetInnerHTML={{
              __html: (isLandingPage() || isPromotionalLandingPage()
                ? NLContent.monthlyPriceInfoLanding
                : NLContent.monthlyPriceInfo
              )
                .replace(
                  "{_price}",
                  GetCurrencyFixedToTwo(
                    isLandingPage() || isPromotionalLandingPage()
                      ? planPerLinesCost
                      : planCost ?? 0
                  )
                )
                .replace(
                  "{_originalPrice}",
                  GetCurrencyFixedToTwo(planCost ?? 0)
                ),
            }}
          />
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ marginTop: "5px", color: "var(--title-color_1)" }}>
            <Typography
              sx={renderTextStyles(1, "12px", "inherit", "18px")}
              dangerouslySetInnerHTML={{
                __html: NLContent.add_charges,
              }}
            />
          </Box>
          <Box
            sx={{
              marginLeft: "10px",
              my: "10px",
              color: "var(--title-color_1)",
            }}
          >
            <Typography sx={renderTextStyles(1, "10px", "inherit", "15px")}>
              {NLContent.monthly_fee_heading}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              alignItems: "center",
              ml: "10px",
              gap: "5px",
            }}
          >
            <Typography sx={renderTextStyles(4, "12px", "inherit", "18px")}>
              {NLContent.cost_rec_heading}
            </Typography>
            <Typography
              sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
                textAlign: "right",
              })}
            >
              {NLContent.cost_rec_value}
            </Typography>
          </Box>
          <Box
            sx={{
              marginLeft: "10px",
              color: "var(--title-color_1)",
              my: "10px",
            }}
          >
            <Typography sx={renderTextStyles(1, "10px", "inherit", "15px")}>
              {NLContent.one_time_fee_heading}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              alignItems: "center",
              m: "0px 0px 14px 10px",
              gap: "5px",
            }}
          >
            <Typography sx={renderTextStyles(4, "12px", "inherit", "18px")}>
              {NLContent.act_fee_heading}
            </Typography>
            <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
              {GetCurrencyFixedToTwo(configKeys?.ACTIVATION_FEE_LINE[1])}{" "}
              {NLContent.act_fee_value}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <Typography sx={renderTextStyles(4, "12px", "inherit", "18px")}>
              {NLContent.sim_ship_heading}
            </Typography>
            <Typography
              sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
                textAlign: "right",
              })}
            >
              {/* {GetCurrencyFixedToTwo(minShipvalue)}&nbsp;
              –&nbsp; */}
              {GetCurrencyFixedToTwo(maxShipvalue)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              my: "10px",
            }}
          >
            <Typography sx={renderTextStyles(1, "10px", "inherit", "15px")}>
              {NLContent.termination_fee_heading}
            </Typography>
            <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
              {NLContent.termination_fee_value}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              alignItems: "center",
              mb: "5px",
            }}
          >
            <Typography sx={renderTextStyles(1, "10px", "inherit", "15px")}>
              {NLContent.govt_taxes_heading}
            </Typography>
            <Typography
              sx={renderTextStyles(
                1,
                "10px",
                "inherit",
                "15px",
                "var(--font_weight_4)",
                "0"
              )}
            >
              {NLContent.govt_taxes_value}
            </Typography>
          </Box>
        </Box>
        {/* <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            color: "var(--title-color_1)",
            mt: "5px",
          }}
        >
          <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
            {NLContent.discount_heading}
          </Typography>
          <Typography
            sx={_.merge(renderTextStyles(4, "10px", "inherit", "15px"), {
              my: "5px",
              mx: "10px",
            })}
          >
            {NLContent.discount_desc}{" "}
            <Link
              sx={_.merge(renderTextStyles(4, "10px", "inherit", "15px"), {
                textDecorationColor: "var(--title-color_1)",
                cursor: "pointer",
              })}
              onClick={() => {
                window.open(configKeys?.DISCOUNTS_BUNDLE_LABEL_URL, "_blank");
              }}
            >
              {NLContent.discount_link}
            </Link>{" "}
            {NLContent.discount_more_text}
          </Typography>
        </Box> */}
        {/* <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            color: "var(--title-color_1)",
            mt: "5px",
          }}
        >
          <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
            {NLContent.acp_heading}
          </Typography>
          <Typography
            sx={_.merge(renderTextStyles(4, "10px", "inherit", "15px"), {
              my: "5px",
              mx: "10px",
            })}
          >
            {NLContent.acp_desc}{" "}
            <Link
              sx={_.merge(renderTextStyles(4, "10px", "inherit", "15px"), {
                textDecorationColor: "var(--title-color_1)",
                cursor: "pointer",
              })}
              onClick={() => {
                window.open(NLContent?.acp_url, "_blank");
              }}
            >
              {NLContent.acp_link}
            </Link>
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
              my: "10px",
            }}
          >
            <Typography sx={renderTextStyles(1, "10px", "inherit", "15px")}>
              {NLContent.acp_part_key}
            </Typography>
            <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
              {NLContent.acp_part_value}
            </Typography>
          </Box>
        </Box> */}
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            color: "var(--title-color_1)",
          }}
          my="5px"
        >
          <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
            {NLContent.speeds_title}
          </Typography>
          {p?.labelInfo?.speedInfos.map((speedInfo: any, index: number) => {
            return (
              <Box key={index}>
                <Box sx={{ color: "var(--title-color_1)" }}>
                  <Typography
                    sx={renderTextStyles(1, "12px", "inherit", "18px")}
                  >
                    {speedInfo?.band}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={renderTextStyles(3, "12px", "inherit", "22.8px")}
                  >
                    {NLContent.download_speed_heading}
                  </Typography>
                  <Typography
                    sx={_.merge(
                      renderTextStyles(1, "12px", "inherit", "18px"),
                      {
                        textAlign: "right",
                      }
                    )}
                  >
                    {speedInfo?.dlSpeed}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={renderTextStyles(3, "12px", "inherit", "22.8px")}
                  >
                    {NLContent.upload_speed_heading}
                  </Typography>
                  <Typography
                    sx={renderTextStyles(1, "12px", "inherit", "18px")}
                  >
                    {speedInfo?.ulSpeed}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "5px",
                  }}
                >
                  <Typography
                    sx={renderTextStyles(3, "12px", "inherit", "22.8px")}
                  >
                    {NLContent.latency_heading}
                  </Typography>
                  <Typography
                    sx={renderTextStyles(1, "12px", "inherit", "18px")}
                  >
                    {speedInfo?.latency}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: "5px",
              color: "var(--title-color_1)",
              gap: "5px",
            }}
          >
            <Typography
              component={"span"}
              sx={renderTextStyles(1, "12px", "inherit", "18px")}
            >
              {NLContent.data_mp_heading}
            </Typography>
            {p?.planSubType !== "PREMIUM" ? (
              <Typography
                component={"span"}
                sx={renderTextStyles(1, "12px", "inherit", "18px")}
              >
                {p?.planData}GB
              </Typography>
            ) : null}
          </Box>
          {p?.planSubType === "PREMIUM" ? (
            <Typography
              sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
                display: "flex",
                justifyContent: "end",
              })}
            >
              {NLContent.unlimitedSpeedInfo?.replace("{planData}", p?.planData)}
            </Typography>
          ) : null}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              color: "var(--title-color_1)",
            }}
          >
            <Typography sx={renderTextStyles(3, "12px", "inherit", "22.8px")}>
              {NLContent.add_charges_data_heading}
            </Typography>
          </Box>
          <Typography
            sx={_.merge(renderTextStyles(1, "12px", "title-color_1", "18px"), {
              display: "flex",
              justifyContent: "end",
            })}
          >
            {NLContent.additional_data_charges}
          </Typography>
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "5px",
              color: "var(--title-color_1)",
              gap: "5px",
            }}
          >
            <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
              {NLContent.net_manage_heading}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Link
                sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
                  cursor: "pointer",
                  textDecoration: "underline",
                  textAlign: "right",
                  whiteSpace: "nowrap",
                })}
                onClick={() => {
                  window.open(
                    configKeys?.NETWORK_MANAGEMENT_LABEL_URL,
                    "_blank"
                  );
                }}
              >
                {NLContent.net_manage_url}
              </Link>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "5px",
              color: "var(--title-color_1)",
              gap: "5px",
            }}
          >
            <Typography sx={renderTextStyles(1, "12px", "inherit", "18px")}>
              {NLContent.privacy_heading}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <Link
                sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
                  cursor: "pointer",
                  textDecoration: "underline",
                })}
                onClick={() => {
                  window.open(configKeys?.PRIVACY_LABEL_URL, "_blank");
                }}
              >
                {NLContent.privacy_url}
              </Link>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            borderBottom: "2px solid var(--title-color_1)",
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            color: "var(--title-color_1)",
          }}
        >
          <Typography
            sx={_.merge(renderTextStyles(1, "12px", "inherit", "18px"), {
              mt: "5px",
              textDecoration: "unset",
            })}
          >
            {NLContent.cust_support_title}
          </Typography>
          <Typography
            sx={_.merge(renderTextStyles(3, "12px", "inherit", "22.8px"), {
              mb: "5px",
            })}
          >
            {NLContent.contact_us_heading}{" "}
            <Link
              sx={_.merge(renderTextStyles(3, "12px", "inherit", "22.8px"), {
                cursor: "pointer",
                textDecoration: "unset",
              })}
              href={`mailto:${configKeys?.BRAND_WEB_SUPPORT_LABEL_URL}`}
            >
              {configKeys?.BRAND_WEB_SUPPORT_LABEL_URL}
            </Link>{" "}
            /<br />
            {configKeys?.BRAND_SUPPORT_MOBILE_NO}
          </Typography>
        </Box>
        <Box
          sx={{
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            my: "5px",
            color: "var(--title-color_1)",
          }}
        >
          <Typography sx={renderTextStyles(4, "10px", "inherit", "15px")}>
            {NLContent.fcc_desc}
          </Typography>
        </Box>
        <Box
          sx={{
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            color: "var(--title-color_1)",
            borderBottom: "2px solid var(--title-color_1)",
          }}
        >
          <Link
            sx={_.merge(renderTextStyles(3, "12px", "inherit", "28px"), {
              textDecoration: "unset",
              cursor: "pointer",
            })}
            onClick={() => {
              window.open("https://www." + NLContent.fcc_url, "_blank");
            }}
          >
            {NLContent.fcc_url}
          </Link>
        </Box>
        <Box
          sx={{
            height: "max-content",
            width: "100%",
            display: " flex",
            flexDirection: "column",
            my: "5px",
            color: "var(--title-color_1)",
          }}
        >
          <Typography sx={renderTextStyles(3, "11px", "inherit", "20.35px")}>
            {NLContent?.UPI}
          </Typography>
          <Typography sx={renderTextStyles(3, "11px", "inherit", "20.35px")}>
            {p?.uniqueIdentifier}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default T2_NLCard;
